import React, { useState } from "react";
import facebook from "../../../images/icons/icons-facebook.png";
import linkedin from "../../../images/icons/icons-linkedin.png";
import telegram from "../../../images/icons/icons-telegramm.png";
import gmail from "../../../images/icons/icons-gmail.png";
import arrowIcon from "../../../images/icons/arrow.png";
import arrowUpIcon from "../../../images/icons/arrow-up.png";
import { Link } from "react-router-dom";
const Contacts = () => {
  const [facebookItemActive, setfacebookActive] = useState(false);
  const [linkedinItemActive, setLinkedinActive] = useState(false);
  const [telegramItemActive, setTelegramActive] = useState(false);
  const [gmailItemActive, setGmailActive] = useState(false);

  const clickContactArrow = (item, setItem) => {
    item ? setItem(false) : setItem(true);
  };
  const facebookinfo = "https://www.facebook.com/dpidhaina";
  const linkedinInfo = "https://www.linkedin.com/in/diana-zayats-2a1b59157/";
  const telegramInfo = "dZayats";
  const gmailInfo = "dpidhaina@gmail.com";

  const linkInfo = (linkto) => {
    return <div className="contacts-info">{linkto}</div>;
  };
  const arrowDown = (item, setItem) => {
    return (
      <img
        src={arrowIcon}
        className="arrow-for-info"
        alt="arrow"
        onClick={() => clickContactArrow(item, setItem)}
      />
    );
  };
  const arrowUp = (item, setItem) => {
    return (
      <img
        src={arrowUpIcon}
        className="arrow-for-info"
        alt="arrow"
        onClick={() => clickContactArrow(item, setItem)}
      />
    );
  };
  const contactInfo = (item, setItem, contactSrc) => {
    return (
      <>
        {item ? arrowUp(item, setItem) : arrowDown(item, setItem)}
        {item ? linkInfo(contactSrc) : null}
      </>
    );
  };
  return (
    <>
      <section className="contacts-section">
        <h1>Ви можете зв'язатися зі мною за допомогою:</h1>
        <p>
          Клікніть по іконці для переходу на посилання або месенджер, або ж на
          стрілку для отримання відповідної інформації:
        </p>
        <div className="contacts col-xs-12 col-sm-12 col-md-12">
          <div className="contacts-item">
            <Link
              to={{
                pathname: "//www.facebook.com/dpidhaina",
              }}
              target="_blank"
            >
              <img
                src={facebook}
                className="contacts-icon"
                alt="facebook-icon"
              />
            </Link>
            {facebookItemActive
              ? arrowUp(facebookItemActive, setfacebookActive)
              : arrowDown(facebookItemActive, setfacebookActive)}
            {facebookItemActive ? linkInfo(facebookinfo) : null}
          </div>
          <div className="contacts-item">
            <Link
              to={{
                pathname: "//www.linkedin.com/in/diana-zayats-2a1b59157/",
              }}
              target="_blank"
            >
              <img
                src={linkedin}
                className="contacts-icon"
                alt="linkedin-icon"
              />
            </Link>
            {contactInfo(linkedinItemActive, setLinkedinActive, linkedinInfo)}
          </div>
          <div className="contacts-item">
            <Link
              to={{
                pathname: "//t.me/dZayats",
              }}
              target="_blank"
            >
              <img
                src={telegram}
                className="contacts-icon"
                alt="telegram-icon"
              />
            </Link>
            {contactInfo(telegramItemActive, setTelegramActive, telegramInfo)}
          </div>
          <div className="contacts-item">
            <img src={gmail} className="contacts-icon" alt="gmail-icon" />
            {contactInfo(gmailItemActive, setGmailActive, gmailInfo)}
          </div>
        </div>
      </section>
    </>
  );
};
export default Contacts;
